<template>
  <div :class="$style.printHeader">
    <BaseText bold>
      {{ filters.date(start, {
          format: 'long',
          addYear: true
        }) }}
      -
      {{ filters.date(end, {
          format: 'long',
          addYear: true
        }) }}
    </BaseText>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import filters from '@/filters';

export default defineComponent({
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
    },
  },
  setup() {
    return {
      filters,
    };
  },
});
</script>

<style
  lang="scss"
  module
>
.printHeader {
  display: none;
  text-align: right;
}

@media print {
  .printHeader {
    display: block;
  }
}
</style>
